"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var react_dom_1 = __importDefault(require("react-dom"));

var react_utils_1 = require("./react-utils");

var listeners = [];
var queries = {};

function matchScreenVariants() {
  if (!react_utils_1.isBrowser) {
    return [];
  }

  return Object.entries(queries).filter(function (_a) {
    var query = _a[1];
    return window.matchMedia(query).matches;
  }).map(function (_a) {
    var name = _a[0];
    return name;
  });
}

var curScreenVariant = [];

function calculateScreenVariant() {
  var screenVariant = matchScreenVariants();

  if (screenVariant !== curScreenVariant) {
    curScreenVariant = screenVariant;
    react_dom_1.default.unstable_batchedUpdates(function () {
      return listeners.forEach(function (listener) {
        return listener();
      });
    });
  }
}

if (react_utils_1.isBrowser) {
  window.addEventListener("resize", calculateScreenVariant);
}

function createUseScreenVariants(isMulti, screenQueries) {
  Object.assign(queries, screenQueries);
  calculateScreenVariant();
  return function () {
    var _a = React.useState(),
        updateState = _a[1]; // We do useLayoutEffect instead of useEffect to immediately
    // register our forceUpdate. This ensures that if there was
    // a window resize event between render and effects, that the
    // listener will be registered in time


    react_utils_1.useIsomorphicLayoutEffect(function () {
      var forceUpdate = function forceUpdate() {
        return updateState({});
      };

      listeners.push(forceUpdate);
      return function () {
        listeners.splice(listeners.indexOf(forceUpdate), 1);
      };
    }, []);
    return isMulti ? curScreenVariant : curScreenVariant[curScreenVariant.length - 1];
  };
}

exports.default = createUseScreenVariants;